import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { EmailValidator } from 'commons-validator-js';
import { isValidPhoneNumber } from 'libphonenumber-js';

export class CustomValidators {
    static notBlank: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { blank: true };
    };

    static email: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        if (control.value == null || control.value.length === 0) {
            return null; // don't validate empty values to allow optional controls
        }
        const validator = new EmailValidator({ allowLocal: true, allowTld: true });
        return validator.isValid(control.value) ? null : { email: true };
    };

    static phone: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        if (control.value == null || control.value.length === 0) {
            return null; // don't validate empty values to allow optional controls
        }
        return isValidPhoneNumber(control.value, 'BE') ? null : { phone: true, message: 'form.error.invalid-phone' };
    };
}
